const urls = [
    'https://api.mvcsky.com/'
];
const defaultUrl = urls[0];
export default defaultUrl;


// WEBPACK FOOTER //
// ./src/ws/urls.js